import { config } from '@/lib/env-helpers';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { MessageType, createClient, stringifyMessage } from 'graphql-ws';
import { createHeaders } from './auth-link';
import { ApolloLink } from '@apollo/client';
import { cache } from './cache';
import { WORKSPACE_AUTH_ME } from '@/graphql/query.graphql';
import { workspaceAuthMeV2Query } from '@/types/generated/graphql';

type Socket = { readyState: unknown; close: (n: number, s: string) => void; send: (_: string) => void };
let activeSocket: Socket, timedOut: NodeJS.Timeout;

function onPing(received: boolean) {
  const workspaceDetails: workspaceAuthMeV2Query | null = cache.readQuery({ query: WORKSPACE_AUTH_ME });
  const { currentUserWorkspace, id: workspaceId } = workspaceDetails?.workspaceAuthMeV2?.data || {};
  const pingPayload = {
    userWorkspaceId: currentUserWorkspace?.id,
    workspaceId,
  };

  if (!received)
    // sent
    timedOut = setTimeout(() => {
      if (activeSocket.readyState === WebSocket.OPEN) activeSocket.close(4408, 'Request Timeout');
    }, 5_000); // wait 5 seconds for the pong and then close the connection

  activeSocket.send(
    stringifyMessage({
      type: MessageType.Ping,
      payload: pingPayload,
    })
  );
}

function onPong(received: boolean) {
  if (received) clearTimeout(timedOut); // pong is received, clear connection close timeout
}

export const subscriptionLink = new GraphQLWsLink(
  createClient({
    retryAttempts: 5,
    keepAlive: 10_000,
    connectionParams: createHeaders,
    url: config.SUBSCRIPTION_ENDPOINT,
    on: {
      connected: (socket) => (activeSocket = socket as Socket),
      ping: onPing,
      pong: onPong,
    },
  })
) as unknown as ApolloLink; // because typecasting issue in src/container/apollo-client/index.ts;
